import { z } from 'zod'

export const AGENTMCP_SUBMIT_READ_CONTRACT_VERSION = '1.0.0' as const

export const agentmcpSubmissionStatusResponseSchema = z.object({
  submission_id: z.string(),
  status: z.string(),
}).passthrough()

export type AgentmcpSubmissionStatusResponse = z.infer<typeof agentmcpSubmissionStatusResponseSchema>
